import { useState } from 'react'
import { Button, Menu, MenuItem, ListItemText, Tooltip } from '@mui/material'
import { KeyboardArrowDown } from '@mui/icons-material'
import { PaymentStatus } from '@typings'
import { PAYMENT_STATUS_LABELS, PAYMENT_STATUS_TRANSITIONS } from 'src/constants/status.constants'
import { TOOLTIPS } from '@constants'

interface StatusChangeMenuProps {
  currentStatus: PaymentStatus | null
  onStatusChange: (newStatus: PaymentStatus) => Promise<void>
  disabled?: boolean
}

export const StatusChangeMenu = ({ currentStatus, onStatusChange, disabled = false }: StatusChangeMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [loading, setLoading] = useState(false)
  const open = Boolean(anchorEl)

  const availableTransitions = currentStatus ? PAYMENT_STATUS_TRANSITIONS[currentStatus] || [] : []

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleStatusChange = async (newStatus: PaymentStatus) => {
    setLoading(true)
    try {
      await onStatusChange(newStatus)
      handleClose()
    } catch (error) {
      console.error('Status change error:', error)
    } finally {
      setLoading(false)
    }
  }

  if (availableTransitions.length === 0) {
    return null
  }

  return (
    <>
      <Tooltip title={TOOLTIPS.CHANGE_PAYMENT_STATUS}>
        <Button
          variant="outlined"
          size="small"
          onClick={handleClick}
          disabled={disabled || loading}
          endIcon={<KeyboardArrowDown />}
          fullWidth>
          Status wijzigen
        </Button>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}>
        {availableTransitions.map(status => (
          <MenuItem
            key={status}
            onClick={() => handleStatusChange(status)}
            disabled={loading}>
            <ListItemText primary={PAYMENT_STATUS_LABELS[status]} />
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
